export default __webpack_public_path__ + "static/media/socialLinkedindark.e340e520.svg";